/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import 'rc-notification/assets/index.css';
import React, { useRef, Component, useEffect } from "react";
import {Card, CardBody,CardTitle, Row, Col, } from 'reactstrap';
import Notification from 'rc-notification';
import { Table, Button, Popconfirm, Upload } from "antd";
// Replace react-excel-renderer with xlsx
import * as XLSX from 'xlsx';
import FullfillmentShipmentResizableTable from './FullfillmentShipmentResizableTable';
import { tableHeaderDataForUploadFullfillmentShipment as tableHeaderData, 
  tableImportFullfillmentShipmentStatusHeader } from "../helper";

export default class FullfillmentShipmentExcelImport extends Component {  
  constructor(props) {  
    
    super(props);
    this.input = React.createRef(); 
   // this.isLoading = false;
    this.tableData = { tableHeaderData: [], tableRowsData: [] };
    this.isEmptyCell = true;
    this.loading = false;
    this.isError = false;
    this.errorMessage = '';
    this.cogsNumberCount = 0;
    this.emptyCellCount = 0;
    this.emptyCellErrorMessage = '';
    this.cogsErrorMessage = '';
    this.fileName = '';
    this.statusMethod = JSON.stringify(this.fillFileStatus());    
    this.state = {
      cols: [],
      rows: [],    
      statusData: [],
      isLoading: false,      
     //  regexp: /^[0-9]*\.?[0-9]*$/,
     // regexp: /^\d*\.?\d*$/,
     // regexp: /[0-9]{1,3}(\\.[0-9]{1,2})?%?")/,
     //  regexp: /^(\d*\.)?\d+$/,
     regexp: /^\$?[0-9.,]+$/,
     // regexp: /(?=.)^\$?(([1-9][0-9]{0,2}(,[0-9]{3})*)|0)?(\.[0-9]{1,2})?$/,
     // regexp: /(?=.*\d)^\$,?(([1-9]\d{0,2}(,\d{3})*)|0)?(\.\d{1,2})?$/,
      errorMessage: null,
      columns: [
        {
          title: "amazon-order-id",
          dataIndex: "amazon-order-id",
          editable: true,
          width: 180
        },
        {
          title: "merchant-order-id",
          dataIndex: "merchant-order-id",
          editable: true,
          width: 220
        },        
        {
            title: "shipment-id",
            dataIndex: "shipment-id",
            editable: true,
            width: 220
        },   
        {
            title: "shipment-item-id",
            dataIndex: "shipment-item-id",
            editable: true,
            width: 220
        },   
        {
            title: "amazon-order-item-id",
            dataIndex: "amazon-order-item-id",
            editable: true,
            width: 220
        },   
        {
            title: "merchant-order-item-id",
            dataIndex: "merchant-order-item-id",
            editable: true,
            width: 220
        },   
        {
          title: "purchase-date",
          dataIndex: "purchase-date",
          editable: true,
          width: 200
        },
        {
          title: "payments-date",
          dataIndex: "payments-date",
          editable: true,
          width: 200
        },
        {
          title: "shipment-date",
          dataIndex: "shipment-date",
          editable: true,
          width: 200
        },   
        {
          title: "reporting-date",
          dataIndex: "reporting-date",
          editable: true,
          width: 200
        },    

        {
            title: "buyer-email",
            dataIndex: "buyer-email",
            editable: true,
            width: 200
          },  

          {
            title: "buyer-name",
            dataIndex: "buyer-name",
            editable: true,
            width: 200
          },  

          {
            title: "buyer-phone-number",
            dataIndex: "buyer-phone-number",
            editable: true,
            width: 200
          },  
          {
            title: "merchant-sku",
            dataIndex: "merchant-sku",
            editable: true,
            width: 200
          },  
          {
            title: "title",
            dataIndex: "title",
            editable: true,
            width: 200
          },  
          {
            title: "shipped-quantity",
            dataIndex: "shipped-quantity",
            editable: true,
            width: 200
          },  
          {
            title: "currency",
            dataIndex: "currency",
            editable: true,
            width: 200
          },            
          {
            title: "item-price",
            dataIndex: "item-price",
            editable: true,
            width: 200
          },  {
            title: "item-tax",
            dataIndex: "item-tax",
            editable: true,
            width: 200
          },  {
            title: "shipping-price",
            dataIndex: "shipping-price",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-tax",
            dataIndex: "shipping-tax",
            editable: true,
            width: 200
          },  
          {
            title: "gift-wrap-price",
            dataIndex: "gift-wrap-price",
            editable: true,
            width: 200
          },  
          {
            title: "gift-wrap-tax",
            dataIndex: "gift-wrap-tax",
            editable: true,
            width: 200
          },  
          {
            title: "ship-service-level",
            dataIndex: "ship-service-level",
            editable: true,
            width: 200
          },  
          {
            title: "recipient-name",
            dataIndex: "recipient-name",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-address1",
            dataIndex: "shipping-address1",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-address2",
            dataIndex: "shipping-address2",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-address3",
            dataIndex: "shipping-address3",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-city",
            dataIndex: "shipping-city",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-state",
            dataIndex: "shipping-state",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-postal-code",
            dataIndex: "shipping-postal-code",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-country-code",
            dataIndex: "shipping-country-code",
            editable: true,
            width: 200
          },  
          {
            title: "shipping-phone-number",
            dataIndex: "shipping-phone-number",
            editable: true,
            width: 200
          },  
          {
            title: "billing-address1",
            dataIndex: "billing-address1",
            editable: true,
            width: 200
          },  
          {
            title: "billing-address2",
            dataIndex: "billing-address2",
            editable: true,
            width: 200
          },  
          {
            title: "billing-address3",
            dataIndex: "billing-address3",
            editable: true,
            width: 200
          },  
          {
            title: "billing-city",
            dataIndex: "billing-city",
            editable: true,
            width: 200
          },  
          {
            title: "billing-state",
            dataIndex: "billing-state",
            editable: true,
            width: 200
          },  
          {
            title: "billing-postal-code",
            dataIndex: "billing-postal-code",
            editable: true,
            width: 200
          },  
          {
            title: "billing-country",
            dataIndex: "billing-country",
            editable: true,
            width: 200
          },  
          {
            title: "item-promo-discount",
            dataIndex: "item-promo-discount",
            editable: true,
            width: 200
          },  
          {
            title: "shipment-promo-discount",
            dataIndex: "shipment-promo-discount",
            editable: true,
            width: 200
          },  
          {
            title: "carrier",
            dataIndex: "carrier",
            editable: true,
            width: 200
          },  
          {
            title: "tracking-numbers",
            dataIndex: "tracking-number",
            editable: true,
            width: 200
          },  
          {
            title: "estimated-arrival-date",
            dataIndex: "estimated-arrival-date",
            editable: true,
            width: 200
          },  
          {
            title: "fc",
            dataIndex: "fc",
            editable: true,
            width: 200
          }, 
          {
            title: "fulfillment-channel",
            dataIndex: "fulfillment-channel",
            editable: true,
            width: 200
          }, 
          {
            title: "sales-channel",
            dataIndex: "sales-channel",
            editable: true,
            width: 200
          }, 
          
        // {
        //   title: "Action",
        //   dataIndex: "action",
        //   render: (text, record) =>
        //     this.state.rows.length >= 1 ? (
        //       <Popconfirm
        //         title="Sure to delete?"
        //         onConfirm={() => this.handleDelete(record.key)}
        //       >
        //         {/* <Icon
        //           type="delete"
        //           theme="filled"
        //           style={{ color: "red", fontSize: "20px" }}
        //         /> */}
        //       </Popconfirm>
        //     ) : null
        // }
      ]
    };
  }    

  calculateProcessingTime = (dateTimeString,modifiedDatetimeString) => {
    console.log(modifiedDatetimeString)

    const year = modifiedDatetimeString.substr(0, 4);
    let month = modifiedDatetimeString.substr(4, 2);
    let day = modifiedDatetimeString.substr(6, 2);
    let hour = modifiedDatetimeString.substr(8, 2);
    let minute = modifiedDatetimeString.substr(10, 2);
    let second = modifiedDatetimeString.substr(12, 2);
    if(modifiedDatetimeString.length > 12){
      month = modifiedDatetimeString.substr(4, 2);
      day = modifiedDatetimeString.substr(6, 2);
      hour = modifiedDatetimeString.substr(8, 2);
      minute = modifiedDatetimeString.substr(10, 2);
      second = modifiedDatetimeString.substr(12, 2);
    } else {
      month = modifiedDatetimeString.substr(4, 1);
      day = modifiedDatetimeString.substr(5, 1);
      hour = modifiedDatetimeString.substr(6, 2);
      minute = modifiedDatetimeString.substr(8, 2);
      second = modifiedDatetimeString.substr(10, 2);
    }
    
    if(hour > 12){
      hour -= 12;
    }

    const requestDate = new Date(dateTimeString)
    const modifiedDate = new Date(year, month - 1, day, hour, minute, second);
    const diff = modifiedDate.getTime() - requestDate.getTime();
    let msec = diff;
    const hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    const mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    const ss = Math.floor(msec / 1000);
    msec -= ss * 1000;
    const processingTime = `${hh}:${mm}:${ss}`;
    // Create and return a new Date object using the extracted values
    return processingTime;
  }

  fillFileStatus = async () => {
    const token = localStorage.getItem('easydev');
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',
      Authorization: token }      
    };
  const response = await fetch('https://rss.getrael.com/api/amazon/fulfillmentshipments/import/status', requestOptions);
  const data = await response.json();
  
  if (data.code === '200')
  {
    
    const currentDataByID = {}

    data?.modal?.data.forEach((item) => {
      if (item && currentDataByID[item?.uuid]) {
        currentDataByID[item?.uuid].push(item)
      }
      else {
        currentDataByID[item?.uuid] = [item]
      }
    });
    console.log(currentDataByID)
    const currentUUID = Object.keys(currentDataByID);
    let finalData = []
console.log(currentUUID)
    const reduceCallback = (acc, day) => {
      
      if (acc[day.statusChangeDateTime]) {
          acc?.[day.statusChangeDateTime]?.push(day)
      } else {
          acc[day.statusChangeDateTime] = [day]
      }
      return acc
  }

    for (let i = 0; i < currentUUID.length; i += 1) {
      const uuid = currentUUID[i];
      const currentMonth = currentDataByID?.[uuid] ?? [];
      const currentDateTimeWise = currentMonth?.reduce(reduceCallback, {});     
      const currentDate = Object.keys(currentDateTimeWise).sort((a,b) => b-a);     
      const dataAfterSort = currentDateTimeWise[currentDate[0]][0]
      finalData.push(currentDateTimeWise[currentDate[0]][0])      
  }
    
    finalData = finalData.map(item => ({
      ...item,
      processingTime: this.calculateProcessingTime(item.dateTime, item.statusChangeDateTime)
      // dateTime: moment(item.dateTime).format("YYYY-MM-DD HH:MM:SS")
    }))    
    this.setState({
      statusData : finalData.sort((a,b) => new Date(b.dateTime).setHours(0, 0, 0, 0) - 
      new Date(a.dateTime).setHours(0, 0, 0, 0))
    })
    // this.state.statusData = data?.modal?.data    
  }  
  else {
   // this.state.isLoading = false;
    Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'File status not ready, Please try again!',
          duration: 10,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 50
        });
      });
    console.log("File status not ready, Please try again!")
  }  
  }   
  
  handleSave = (row) => {
    const newData = [...this.state.rows];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    this.setState({ rows: newData });
  };

  clearData = () => {
    this.setState({ rows: [] })
    this.input.current.value = ""
  }

  // New Excel import function using xlsx instead of react-excel-renderer
  onImportExcel = (event) => {
    const { files } = event.target;
    
    if (files.length === 1) {      
      this.fileName = files[0].name;
      
      // Check file type
      if (!(files[0].type === "application/vnd.ms-excel" || 
      files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      || files[0].type === "text/csv")) 
      {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Unknown file format. Only Excel files are uploaded!',
            duration: 5,
            closable: true,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        }); 
        this.setState({
          errorMessage: "Unknown file format. Only Excel files are uploaded!"
        });      
        return false;
      }

      // Use FileReader to read the file
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          // Get the first worksheet
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          
          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
            header: 1, // Use array of arrays format
            defval: '' // Default value for empty cells
          });

          const newRows = [];
          
          // Process rows (skip header row)
          jsonData.slice(1).forEach((row, index) => {
            if (row && row.length > 0) {
              newRows.push({
                key: index,
                amazonOrderId: String(row[0] || ''),
                merchantOrderId: String(row[1] || ''),                             
                shipmentId: String(row[2] || ''),
                shipmentItemId: String(row[3] || ''),
                amazonOrderItemId: String(row[4] || ''),
                merchantOrderItemId: String(row[5] || ''),
                purchaseDate: String(row[6] || ''),
                paymentsDate: String(row[7] || ''),
                shipmentDate: String(row[8] || ''),
                reportingDate: String(row[9] || ''),
                buyerEmail: String(row[10] || ''),
                buyerName: String(row[11] || ''),
                buyerPhoneNumber: String(row[12] || ''),
                merchantSku: String(row[13] || ''),
                title: String(row[14] || ''),
                shippedQuantity: String(row[15] || ''),
                currency: String(row[16] || ''),
                itemPrice: String(row[17] || ''),
                itemTax: String(row[18] || ''),
                shippingPrice: String(row[19] || ''),
                shippingTax: String(row[20] || ''),
                giftWrapPrice: String(row[21] || ''),
                giftWrapTax: String(row[22] || ''),
                shipServiceLevel: String(row[23] || ''),
                recipientName: String(row[24] || ''),
                shippingAddress1: String(row[25] || ''),
                shippingAddress2: String(row[26] || ''),
                shippingAddress3: String(row[27] || ''),
                shippingCity: String(row[28] || ''),
                shippingState: String(row[29] || ''),
                shippingPostalCode: String(row[30] || ''),
                shippingCountryCode: String(row[31] || ''),
                shippingPhoneNumber: String(row[32] || ''),    
                billingAddress1: String(row[33] || ''),
                billingAddress2: String(row[34] || ''),          
                billingAddress3: String(row[35] || ''),
                billingCity: String(row[36] || ''),
                billingState: String(row[37] || ''),
                billingPostalCode: String(row[38] || ''),
                billingCountry: String(row[39] || ''),
                itemPromoDiscount: String(row[40] || ''),
                shipmentPromoDiscount: String(row[41] || ''),
                carrier: String(row[42] || ''),
                trackingNumber: String(row[43] || ''),
                estimatedArrivalDate: String(row[44] || ''),
                fc: String(row[45] || ''),
                fulfillmentChannel: String(row[46] || ''),
                salesChannel: String(row[47] || ''),
              });                
            }
          });          
          
          if (this.isError === true) {
            this.errorMessage = this.cogsErrorMessage;
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: <span>{this.errorMessage}</span>,
                duration: 10,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
                onClick() {
                  console.log('clicked!!!');
                },
                style: {top: 120, fontWeight: "bold"},
              });
            }); 
          } else {
            this.isError = false;
            this.isEmptyCell = true;
          }

          if (newRows.length === 0) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: {top: 120, fontWeight: "bold"},
                maxCount: 50
              });
            });            
          } else {
            this.isEmptyCell = false;
            
            this.setState({
              cols: jsonData[0] || [], // Header row
              rows: newRows,
              errorMessage: null
            });

            console.log(this.state.rows.length);
          }
        } catch (error) {
          console.error('Error reading Excel file:', error);
          Notification.newInstance({}, (notification) => {
            notification.notice({
              content: 'Error reading Excel file. Please check the file format.',
              duration: 10,
              style: {top: 120, fontWeight: "bold"},
              maxCount: 50
            });
          });
        }
      };

      // Read the file as array buffer
      reader.readAsArrayBuffer(files[0]);
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'No file uploaded!',
          duration: 10,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 50
        });
      });
      this.setState({
        errorMessage: "No file uploaded!"
      });
      return false;
    }
    return false;
  }; 

  handleSubmit = async () => {
    this.state.isLoading = true;
    this.loading = true;
    this.isEmptyCell = true;
    this.setState({isLoading: true});
   
    const token = localStorage.getItem('easydev');
   
    const requestData = {
      fileName: this.fileName,
      data: this.state.rows
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',
      Authorization: token },
      body: JSON.stringify(requestData)
  };
  const response = await fetch('https://rss.getrael.com/api/amazon/fulfillmentshipments/import', requestOptions);
//   const response = await fetch('http://localhost:8081/api/amazon/fulfillmentshipments/import', requestOptions);
  const data = await response.json();
  this.setState({
    rows: [],
    errorMessage: null
  });
  this.fillFileStatus()
  // window.location.reload(false)  
    
      if (data.code === '200')
      {
        this.setState({isLoading: false});
        this.state.isLoading = false;
        this.loading = false;
        // history.push('/amazon/order')
       await Notification.newInstance({}, (notification) => {
          notification.notice({
            content: `${data?.modal?.data[0]?.fileName} ${data?.modal?.data[0]?.status}`,
            duration: 10,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        });
        
      }
      else
      {
        this.setState({isLoading: false});
        this.state.isLoading = false;
        this.loading = false;
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: "File has not been imported! Please try again.",
            duration: 10,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        });
      }  

      console.log(this.loading)
  };

  handleDelete = (key) => {
    const rows = [...this.state.rows];
    this.setState({ rows: rows.filter(item => item.key !== key) });
  };
 
  handleAdd = () => {
    const { count, rows } = this.state;
    const newData = {
      key: count,
      name: "User's name",
      age: "22",
      gender: "Female"
    };
    this.setState({
      rows: [newData, ...rows],
      count: count + 1
    });
  };

  render() {
    const components = {
      body: {
      //  row: EditableFormRow,
      //  cell: EditableCell
      }
    };
    const columns = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave
        })
      };
    });
    console.log(this.state.statusData)
    return (     
      <Col md={12}>            
          <Row className="product-table-wrap">   
            <Card className="pb-3">
              <CardBody className="dashboard__card-widget card-shadow p-3 mb-10">
                <Row>
                  <Col md="12">
                    <h4 className="bold-text text-center" tag="h3">Upload Fullfillment Shipment</h4>
                  </Col>
                </Row>
                <hr/>
                <Row>          
                <Col md="6">
                  <input className="file-uploader" type="file" accept=".xlsx, .xls" onChange={this.onImportExcel} 
                  ref={this.input} />
                  &nbsp;<Button className="btn btn-sm btn-danger"
                            style={{ marginTop: 16 }}
                            onClick={this.clearData}
                          // onClick={() => this.setState({ rows: [] })}
                            >            
                          &nbsp;Clear
                        </Button> 
                </Col>
                <Col md="6" align="right">
                  {/* {this.state.rows.length > 0 && (
                    <>                */}
                      <Button
                        onClick={this.handleSubmit}
                        size="large"
                        type="primary"
                        className="btn btn-primary btn-sm"
                        disabled={this.isEmptyCell}
                        style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
                      >
                        {!this.loading && <span className='indicator-label'>Submit Data</span>}
                        {this.loading && (
                          <div className="smallload__icon-wrap">
                            <svg className="load__icon">
                                <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                            </svg>
                          </div>
                        )}                        
                      </Button>
                    {/* </>
                  )} */}
                  {/* <Button
                        onClick={() => history.push('/amazon/order')}
                        size="large"
                        type="danger"
                        className="btn btn-primary btn-sm"
                        style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
                      >
                      Back To Order
                  </Button>             */}
                </Col>  
                </Row>
                <hr/>
                <Row>       
                <Col md={12} lg={12}>
                    {this.state.rows.length ? (
                      // this.state.isLoading ? (
                      //   <>                 
                      //     <div
                      //       style={{ minHeight: '200px' }}
                      //       className="row align-items-center justify-content-center"
                      //     >
                      //       <SmallLoader loading={this.state.isLoading} />
                      //     </div>
                      //   </>) : 
                        <FullfillmentShipmentResizableTable customClass="pt-0"
                        reactTableData={{tableHeaderData}} data={this.state.rows} type='file' />
                    ) : <div>No data preview available.
                    </div>}               
                </Col>
                </Row>
              </CardBody>
            </Card>
          </Row> 
          {this.state.statusData &&          
            <Row className="product-table-wrap mt-10">
              <Card className="pb-3">
                <CardBody className="dashboard__card-widget card-shadow p-3">
                  <Col md={12} lg={12}>                  
                      <h4 className="bold-text text-center" tag="h3">
                      Imported file status
                      </h4>                   
                  </Col>
                  <hr/>
                  <Col md={12} lg={12}>                            
                      <FullfillmentShipmentResizableTable customClass="pt-0"
                      reactTableData={{tableImportFullfillmentShipmentStatusHeader}} 
                      data={this.state.statusData} type='status' />                            
                  </Col>
                </CardBody>
              </Card>
            </Row>               
      }   
      </Col>    
    );
  }
}